import { jsx as _jsx } from "react/jsx-runtime";
import { useVirtualizer } from "@tanstack/react-virtual";
import { forwardRef, memo, useImperativeHandle, useRef } from "react";
import { useGetTopVisibleElementIndex } from "../hooks/useGetTopVisibleElementIndex";
import { isiOS } from "../utils/isiOS";
export const DEFAULT_PDF_PAGE_HEIGHT = 500;
export const PDF_LIST_SCROLL_MARGIN = 12;
export const PDF_PAGE_VERTICAL_PADDING = 8;
const _PDFPagesVirtualizedList = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { rowsCount, children, getPageHeight, onTopVisibleElementChange } = param;
    var _virtualItems_;
    const listRef = useRef(null);
    const scrollElementRef = useRef(null);
    const virtualizer = useVirtualizer({
        count: rowsCount,
        getScrollElement: ()=>scrollElementRef.current,
        paddingEnd: 30,
        estimateSize: (index)=>getPageHeight(index) + 2 * PDF_PAGE_VERTICAL_PADDING,
        overscan: isiOS() ? 1 : 6,
        scrollMargin: PDF_LIST_SCROLL_MARGIN
    });
    virtualizer.shouldAdjustScrollPositionOnItemSizeChange = ()=>false;
    useGetTopVisibleElementIndex({
        virtualizer,
        onTopVisibleElementChange
    });
    useImperativeHandle(forwardedRef, ()=>({
            getScrollElement: ()=>virtualizer.scrollElement,
            scrollToIndex: function(index) {
                let align = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "start";
                return virtualizer.scrollToIndex(index, {
                    align
                });
            },
            updateItemsSize: ()=>virtualizer.measure()
        }), [
        virtualizer
    ]);
    const virtualItems = virtualizer.getVirtualItems();
    var _virtualItems__start;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "PDF_PAGES_LIST",
        ref: scrollElementRef,
        className: "w-full flex-1 overflow-auto pl-4 scrollbar scrollbar-track-grey-2 scrollbar-thumb-grey-7 [&:not(:hover)]:scrollbar-track-transparent",
        children: /*#__PURE__*/ _jsx("div", {
            ref: listRef,
            className: "relative w-full",
            style: {
                height: virtualizer.getTotalSize()
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: "absolute left-0 top-0 w-full",
                style: {
                    transform: "translateY(".concat((_virtualItems__start = (_virtualItems_ = virtualItems[0]) === null || _virtualItems_ === void 0 ? void 0 : _virtualItems_.start) !== null && _virtualItems__start !== void 0 ? _virtualItems__start : 0, "px)")
                },
                children: virtualItems.map((virtualRow)=>/*#__PURE__*/ _jsx("div", {
                        "data-index": virtualRow.index,
                        ref: virtualizer.measureElement,
                        className: "py-2",
                        children: children({
                            index: virtualRow.index
                        })
                    }, virtualRow.key))
            })
        })
    });
});
_PDFPagesVirtualizedList.displayName = "PDFPagesVirtualizedList";
export const PDFPagesVirtualizedList = /*#__PURE__*/ memo(_PDFPagesVirtualizedList);
PDFPagesVirtualizedList.displayName = "PDFPagesVirtualizedList";
